<!--
 * @Author: yang bo
 * @Date: 2019-12-03 14:26:45
 * @LastEditors: yang bo
 * @LastEditTime: 2019-12-05 17:33:09
 * @Description:
 -->
<template>
  <el-menu
    :unique-opened="true"
    router
    :default-active="$route.path"
    mode="horizontal"
    @select="handleSelect"
  >
    <div class="user-menu-box" v-for="menu in menus" :key="menu.id">
      <el-menu-item v-if="!menu.child" :index="menu.path">
        <span slot="title" v-text="menu.name"></span>
      </el-menu-item>
      <el-submenu v-if="menu.child" :index="menu.path">
        <template slot="title">
          <span slot="title" v-text="menu.name"></span>
        </template>
        <el-menu-item-group>
          <el-menu-item
            v-for="subMenu in menu.child"
            :key="subMenu.id"
            v-text="subMenu.name"
            :index="subMenu.path"
          ></el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </div>
  </el-menu>
</template>

<script>
export default {
  data() {
    return {
      activeMenu: "",
      indexBreadcrumbs: [],
      menus: [
        // {
        //   id: "1",
        //   name: "订单管理",
        //   path: "#2",
        //   child: [
        //     {
        //       id: "1-1",
        //       name: "全部订单",
        //       path: "/all-order"
        //     },
        //     {
        //       id: "1-2",
        //       name: "人工审核",
        //       path: ""
        //     },
        //     {
        //       id: "1-3",
        //       name: "异常订单",
        //       path: "/abnoermal-order"
        //     }
        //   ]
        // },
        {
          id: "2",
          name: "进件配置",
          icon: "yunpan",
          path: ""
        },
        {
          id: "3",
          name: "策略管理",
          path: "#3",
          child: [
            {
              id: "3-1",
              name: "策略监控",
              path: "/homepage"
            },
            {
              id: "3-2",
              name: "决策引擎",
              path: "/homepage"
            },
            {
              id: "3-3",
              name: "数据运营",
              path: "/homepage"
            }
          ]
        },
        {
          id: "4",
          name: "名单库",
          path: "#4",
          child: [
            {
              id: "4-1",
              name: "风险名单库",
              path: ""
            },
            {
              id: "4-2",
              name: "黑名单库",
              path: ""
            }
          ]
        },
        {
          id: "5",
          name: "变量中心",
          path: "#5",
          child: [
            {
              id: "5-1",
              name: "变量中心",
              path: ""
            },
            {
              id: "5-2",
              name: "征信源管理",
              path: ""
            }
          ]
        }
      ]
    };
  },
  watch: {
    $route(e, y) {
      console.log(e, y);
      this.handChange();
    }
  },
  computed: {
    breadcrumbList() {
      let breadcrumbs = [];
      let menuList = this.menus;
      this.indexBreadcrumbs.map(item => {
        for (let i = 0; i < menuList.length; i++) {
          if (item === menuList[i].path) {
            breadcrumbs.push(menuList[i]);
            if (menuList[i].child) {
              menuList = menuList[i].child;
            }
            break;
          }
        }
      });
      return breadcrumbs;
    }
  },
  methods: {
    handChange() {
      this.$emit("handchange", this.breadcrumbList);
    },
    handleSelect(index, indexPath) {
      console.log(indexPath);
      this.indexBreadcrumbs = indexPath;
    }
  },
  created() {
    this.handChange();
  }
};
</script>

<style scoped>
.user-menu-box {
  float: left;
}
.user-menu-box .el-submenu__title span {
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/include/Menu.vue